import classNames from "classnames";
import {ReactNode} from "react";

import {PropsWithClassName} from "@/lib/types/props.ts";

import styles from "./ActionBarWrapper.module.scss";

interface ActionBarWrapperProps extends PropsWithClassName {
  left?: ReactNode;
  right?: ReactNode;
}

export const ActionBarWrapper = ({left, right, className}: ActionBarWrapperProps) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.left}>{left}</div>
      <div className={styles.right}>{right}</div>
    </div>
  );
};
